import { institutionLogoMap, resolveInstitutionLogoKey } from '@/lib/institutionLogos';

// A logo sai do catálogo do app (`lib/institutionLogos.ts`), o mesmo das telas do celular: as
// chaves são os SVGs de `assets/institutions` e os apelidos casam pelo nome. Logo nova ou apelido
// novo no app vale aqui no próximo build, sem lista copiada pra envelhecer.

/**
 * Devolve o slug do SVG (sem extensão) ou null quando não há logo: o ícone escolhido primeiro;
 * sem ele, o banco digitado e depois o nome da conta ou do cartão.
 */
export function resolveInstitutionIcon(icon: string | null | undefined, ...names: Array<string | null | undefined>): string | null {
  if (icon && icon !== 'default') {
    // Mesma ordem do app (resolveLogoKeyFromPair): apelido e, senão, a chave exata, que com
    // hífen ("banco-do-brasil") não sobrevive à normalização do texto.
    const key = resolveInstitutionLogoKey(icon) ?? (icon in institutionLogoMap ? icon : undefined);
    if (key) return key;
  }
  for (const name of names) {
    const key = resolveInstitutionLogoKey(name);
    if (key) return key;
  }
  return null;
}

export const ACCOUNT_TYPE_LABEL: Record<string, string> = {
  checking: 'Conta corrente',
  savings: 'Poupança',
  wallet: 'Dinheiro',
  digital: 'Conta digital',
  investment: 'Investimento',
  other: 'Outra',
};
